import { FeatureLabel3D } from '../procedural/FeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from '../procedural/SurfaceLineFeature3D'
import { useSurfaceProps } from '@asset-viz/objects/surfaces/util/SurfaceProvider'
import React from 'react'
import {
  GeckoComponentCoords,
  GeckoComponentPolygon,
  GeckoShipDeckLadder,
} from 'types'

/**
 * @param model
 * @constructor
 */
export const DeckLadderFeature3D: React.FC<{
  model: GeckoShipDeckLadder
}> = ({ model }) => {
  const { bounds, wrapMode } = useSurfaceProps()

  const coords = model.coordinates

  const xCoords = coords.map((point) => point.x.num)
  const yCoords = coords.map((point) => point.y.num)
  const minX = Math.min(...xCoords)
  const maxX = Math.max(...xCoords)
  const minY = Math.min(...yCoords)
  const maxY = Math.max(...yCoords)

  // Calculate center position
  const centerX = (minX + maxX) / 2
  const centerY = (minY + maxY) / 2

  // Create center geometry for SurfaceFeature3D
  const firstPoint = coords[0]
  const centerGeometry = GeckoComponentCoords.CreateFromValues(
    bounds.componentID,
    centerX,
    firstPoint.x.unit,
    centerY,
    firstPoint.y.unit
  )

  const outlinePath = React.useMemo(
    () =>
      GeckoComponentPolygon.CreateFromPolygonalPlate(
        model.coordinates,
        bounds,
        wrapMode
      ),
    [bounds, model.coordinates, wrapMode]
  )

  return (
    <>
      <FeatureLabel3D
        feature={model}
        coords={centerGeometry}
        anchor={'bottom'}
      />
      <SurfaceLineFeature3D
        path={outlinePath}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
    </>
  )
}
